module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Bluetooth-a34ef9dc02cf5cd5fb97fac7e49d4d30.svg";